module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAABH0lEQVQ4ja3TMUtCURiH8Z96KSKoPkD0FUSohr5AELRE1NjW1NBmS7W6Bg0JQi2RS0QREQQ5tbQ1Nbe7hE2i2XCPaZqG2gOHw733f597zn3Pm8jlcmmcIY2EwWjgBVsRCnjAJmoDiiJsoxAhg3W8DShpcozdJFL4HFICdaSSIwh+0CmaxFqYmyxg/o9Ml+gQlzgI1zN4CmO6RwbxX2/nEcthhgpuxWX+6JH5VXQfRpN62Ea/DLq3NjT/KipjdgTHHMoR8iiKK1ENDxu4wnPHSxlsaPXkmLgrTiLs4xVLWmdjQlyVVZTCvUXc4VqrJ2vYw0UUvn4eRjsl3GAF7+JjsBNW/002m0V3+ds5xVSQVcPKi73C/URwhHFxU+f7Bb8AQgw9dUIJOFcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhuzhou/icon4.png
// module id = C56p
// module chunks = 1